import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
const getToken = () => localStorage.getItem("admintoken");

export const createNews = async (newsData) => {
  const config = { headers: { Authorization: `Bearer ${getToken()}` } };
  const response = await axios.post(
    `${API_URL}/api/admin/news`,
    newsData,
    config,
  );
  return response.data;
};

export const uploadImage = async (file, slug) => {
  const formData = new FormData();
  formData.append("file", file);
  const config = { headers: { Authorization: `Bearer ${getToken()}` } };
  const response = await axios.post(
    `${API_URL}/api/upload/image/${slug}`,
    formData,
    config,
  );
  return response.data;
};

export const fetchAllNews = async () => {
  const config = { headers: { Authorization: `Bearer ${getToken()}` } };
  const response = await axios.get(`${API_URL}/api/news`, config);
  return response.data;
};

export const deleteNews = async (slug) => {
  const config = { headers: { Authorization: `Bearer ${getToken()}` } };
  const response = await axios.delete(
    `${API_URL}/api/admin/news/${slug}`,
    config,
  );
  return response.data;
};

export const updateNews = async (slug, newsData) => {
  const config = { headers: { Authorization: `Bearer ${getToken()}` } };
  const response = await axios.put(
    `${API_URL}/api/admin/news/${slug}`,
    newsData,
    config,
  );
  return response.data;
};

export const registerAdmin = async (email, password) => {
  const config = { headers: { Authorization: `Bearer ${getToken()}` } };
  const response = await axios.post(
    `${API_URL}/api/auth/register`,
    { email, password },
    config,
  );
  return response.data;
};
